import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'
import moment from 'moment'

type PromoUpdateRequest = {
    type: typeof ActionTypes.PROMO_UPDATE_REQUEST;
    payload: never;
}

type PromoUpdateFailure = {
    type: typeof ActionTypes.PROMO_UPDATE_FAILURE;
    payload: Error;
}

type PromoUpdateSuccess = {
    type: typeof ActionTypes.PROMO_UPDATE_SUCCESS;
    payload: Promo;
}

const UpdateDeviceFields = [
    'date_end',
    'date_start',
    'exception_countries',
    'exception_dates',
    'exception_devices',
    'exception_price_gt',
    'exception_price_lt',
    'exception_stores',
    'exception_skus',
    'group_brand',
    'group_skus',
    'name',
    'priority',
    'type',
] as const

/**
 * Update one promo given its ID
 */
function updatePromo(promo: Promo) {
    const body = ObjectUtils.copy(promo, UpdateDeviceFields, {
        date_start: (v: Date) => moment(v).format('YYYY-MM-DD'),
        date_end: (v: Date) => moment(v).format('YYYY-MM-DD'),
        group_skus: ArrayUtils.cleanStringArray,
        exception_countries: ArrayUtils.cleanStringArray,
        exception_dates: (v: Date[]) => v.map((d) => moment(d).format('YYYY-MM-DD')).join(','),
        exception_devices: ArrayUtils.cleanStringArray,
        exception_stores: ArrayUtils.cleanStringArray,
        exception_skus: ArrayUtils.cleanStringArray,
    })


    return createAction<RootState, Promo, never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos/${promo.id}`,
        method: 'PUT',
        body: JSON.stringify(body),
        types: [
            ActionTypes.PROMO_UPDATE_REQUEST,
            ActionTypes.PROMO_UPDATE_SUCCESS,
            ActionTypes.PROMO_UPDATE_FAILURE,
        ],
    })
}

export type PromoUpdateAction = PromoUpdateRequest
    | PromoUpdateFailure
    | PromoUpdateSuccess

export default updatePromo
